export const PRODUCT_COLORS: Record<string, { class: string; selectedClass: string }> = {
  'Noir et beige': { class: 'bg-[#343534]', selectedClass: 'ring-[#C3945F]' },
  'Beige et marron claire': { class: 'bg-[#AE7B4A]', selectedClass: 'ring-[#DFC08F]' },
}
